class stickyCart {
    constructor(mainContent, stickyCart) {
        this.mainContent = document.querySelector(mainContent);
        this.stickyCart = document.querySelector(stickyCart);
        this.stickyCartForm = this.stickyCart.querySelector('form');
        this.submitButton = this.stickyCartForm.querySelector('button[type="submit"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.init();
    }

    init() {
        const productContentPosition = this.mainContent.getBoundingClientRect().top;
        const checkPosition = () => {
            const scrollY = window.scrollY;
    
            if (scrollY > productContentPosition) {
                this.stickyCart.classList.add('show');
                document.body.classList.add('sticky-cart-visible');
            } else {
                this.stickyCart.classList.remove('show');
                document.body.classList.remove('sticky-cart-visible');
            }
        };
    
        checkPosition();    
        window.addEventListener('scroll', checkPosition);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new stickyCart('.product-main-wrapper product-form button[name="add"]', '#sticky-cart');
});